export default __webpack_public_path__ + "static/xy-histogram-with-mean-aggregation-4a2af4f4db2a5927cd859b363b0598bc.png";